//primer hijo que se mue
import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";



const CarnetUsuario = ({ handleContinuar, errors, values, handleAtras }) => {
  const { resetForm } = useFormikContext();

  return (
    <>
      <div className="px-4">
        <h1 className="font-bold text-center text-white text-lg">
          Busca tu nombre de usuario
        </h1>
        <h1 className="font-bold text-center text-white text-lg">
          (alias familia)
        </h1>
        <h1 className="mt-4 font-semibold text-left text-white text-base">
          Introduce tu carnet para visualización de tu usuario
        </h1>
        <h1 className="font-semibold text-left text-white text-base">
          y alias de familia, ingresa el número de carnet de tu hijo.
        </h1>
      </div>
      <div className="px-4 py-10">
        <label htmlFor="carnet" className="font-bold text-white text-base">
          Carnet
        </label>
        <Field
          type="text"
          name="carnet"
          id="carnet"
          className="flex flex-col w-full items-center mb-2  rounded-md border-gray-300  focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
          placeholder="Escribe aquí tu Carnet"
        />
        <ErrorMessage
          component="p"
          name="carnet"
          className="w-full text-right text-sm font-semibold text-red-500"
        />
        <div
        className="flex gap-2"
        >
        <button
        className="w-full mt-4 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
        type="button"
        name="carnetUsuario"
        onClick={(e)=>{handleAtras(e.target); resetForm()}}
        >
          Atrás
        </button>
        <button
          className="w-full mt-4 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
          type="submit"
        >
          Siguiente
        </button>
        </div>
      </div>
    </>
  );
};

export default CarnetUsuario;
